export const IMAGE_RESOLUTIONS = [
  { id: '4:3', label: 'Standard landscape', width: 1024, height: 768 },
  { id: '3:4', label: 'Standard portrait', width: 768, height: 1024 },
  { id: '16:9', label: 'Widescreen', width: 1920, height: 1080 },
  { id: '9:16', label: 'Portrait screen', width: 1080, height: 1920 },
  { id: '4:5', label: 'Instagram portrait', width: 1080, height: 1350 },
  { id: '1:1', label: 'Square', width: 1080, height: 1080 },
  { id: '1.91:1', label: 'Instagram landscape', width: 1910, height: 1000 },
  { id: '468:60', label: 'Banner', width: 468, height: 60 },
  { id: '728:90', label: 'Leaderboard', width: 728, height: 90 },
  { id: '300:250', label: 'Inline rectangle', width: 300, height: 250 },
  { id: '120:600', label: 'Skyscraper', width: 120, height: 600 },
  { id: '300:600', label: 'Half-page', width: 300, height: 600 },
  { id: '970:90', label: 'Large leaderboard', width: 970, height: 90 },
]

